import React, { useState } from "react"
import Navbar from "../../components/Navbar"
import DashboardContainer from "../Dashboard/DashboardContainer"
import Card from "../../components/Card"
import { Button } from "../../components/Buttons"
import EMICalculator from "../../components/EMICalculator.js"
import CreditScore from "../../components/CreditScore/index.js"
import RecomendedLoanSection from "./component/RecomendedLoanSection.js"

import Carousel from "../../components/Carousel/index.js"
import AboutUsSection from "./component/AboutUsSection.js"
import LoanProductSection from "./component/LoanProductSection.js"
import GetStartedComponent from "./component/GetStartedComponent.js"
import AccessCard from "./component/AccessCard.js"
import PersonalLoanListCard from "./component/PersonalLoanListCard.js"
import EMIDueSection from "./component/EMIDueSection.js";
import groupImage from "../../assets/Images/Home/Group 421.png";
import { useSelector } from "react-redux";
import OtherUserDetails from "./component/OtherUserDetails.js"
import Headings from "../../components/Texts/Headings.js"
import Paragraphs from "../../components/Texts/Paragraphs.js"

const Home = () => {
  const { name, phoneNumber } = useSelector((state) => state.user);
  return (
    <>
      <Navbar />
      {/*  <InstantLoanSection/> */}
      <DashboardContainer>
        <div className="mt-[50px]">
          <Headings
            text={`  Hi ${name || phoneNumber}`}
          />
          <Paragraphs
            text=" Embrace the speed of life with confidence, knowing that we will
            support you in achieving financial stability!"
            className="mt-2"
          />
        </div>
        <div className="grid md:grid-cols-6 grid-cols-1 gap-[24px] mt-[20px]">
          <div className="col-span-1 md:col-span-2 flex justify-center">
            <CreditScore />
          </div>
          <div className="col-span-1 md:col-span-4 flexCol justify-center">
            <GetStartedComponent />
          </div>
        </div>
        <div>
          <PersonalLoanListCard />
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 mt-[60px] md:mt-[120px]">
          <div className="col-span-2">
            <Headings
              variant="tertiary"
              className="text-[#262626]"
              text="Refer to a Friend and get ₹500 off"
            />
            <Paragraphs
              text="Lorem ipsum dolor sit amet, consectetur adipiscing elit Lorem ipsum dolor sit amet, consectetur adipiscing elit"
              className="text-[#262626] mt-[16px]"
              variant="secondary"
            />
            <Card className={"mt-[24px]"}>
              <div class="flex flex-row flex-1 p-[16px] md:p-[20px] border-[1px] rounded-[10px] border-[#42495233] bg-[#42495208] justify-between">
                <input type="text" inputmode="numeric" pattern="[0-9]*" placeholder="Enter code" class="bg-[transparent] max-w-[526px] w-[80dvw] border-0 " value="" />
                <span class="mr-[10px]">copy</span> </div>
              <div className="mt-[12px]">
                <Button
                  // variant="secondary"
                  title={"Share"}
                />
              </div>
            </Card>
          </div>
          <div className="col-span-1 place-items-center order-first md:order-last">
            <img src={groupImage} className="w-[140.77px] h-[124.29px]
            sm:w-[240px] sm:h-[240px]
             lg:w-[340px] lg:h-[340px]
            " />
          </div>
        </div>
        <AboutUsSection />
        <EMICalculator />
        <RecomendedLoanSection />
        <LoanProductSection />
        {/* <div className="my-[160px]">
          <AccessCard />
        </div> */}
        <div className="mt-[60px] md:mt-[160px]">
          <Carousel />
        </div>
      </DashboardContainer>
    </>
  )
}

export default Home
